<nav class="navbar navbar-expand-lg navbar-light" id="topnav">
  <div class="container">

    <!-- Toggler -->
    <button aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler mr-auto"
            data-target="#navbar" data-toggle="collapse" type="button">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Brand -->
    <a class="navbar-brand mr-auto" href="/">
      <img alt="..." class="navbar-brand-img" src="../../../assets/images/logo-blue@3x.png">
    </a>

    <!-- User -->
    <div class="navbar-user">
      <!-- Dropdown -->
      <div class="dropdown">

        <!-- Toggle -->
        <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown" href="#"
           role="button">
          <!--          <i class="fad fa-user-circle fa-2x"></i>-->
          <img [src]="pictureUrl" style="height: 42px;width: 42px;border-radius: 21px;">
        </a>

        <!-- Menu -->
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#">{{ this.email }}</a>
          <a class="dropdown-item" href="#">Paramètres</a>
          <div class="dropdown-divider"></div>
          <a (click)="auth.logout({
          logoutParams: {
            returnTo: getReturnUrl()
          }
          })" class="dropdown-item" href="#"><i class="fad fa-sign-out-alt"></i> Se déconnecter</a>
        </div>

      </div>

    </div>

    <!-- Collapse -->
    <div class="collapse navbar-collapse mr-lg-auto order-lg-first" id="navbar">

      <!-- Navigation -->
      <ul class="navbar-nav mr-lg-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/">Accueil <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item dropdown">
          <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle @@if(category=='pages'){active}"
             data-toggle="dropdown"
             href="#" id="topnavPages" role="button">
            Calculs <i class="fas fa-chevron-down"></i>
          </a>
          <ul aria-labelledby="topnavPages" class="dropdown-menu">
            <li>
              <a class="dropdown-item @@if(page=='wizard.html'){active}" routerLink="/calculations/vehicles">
                Location vs Achat véhicule
              </a>
            </li>
          </ul>
        </li>
      </ul>

    </div>

  </div> <!-- / .container -->
</nav>


<!--<nav class="navbar navbar-expand-lg navbar-light bg-light">-->
<!--  <a class="navbar-brand" href="#">Opti-Impôt</a>-->
<!--  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">-->
<!--    <span class="navbar-toggler-icon"></span>-->
<!--  </button>-->

<!--  <div class="collapse navbar-collapse" id="navbarSupportedContent">-->
<!--    <ul class="navbar-nav mr-auto">-->
<!--      <li class="nav-item active">-->
<!--        <a class="nav-link" routerLink="/">Accueil <span class="sr-only">(current)</span></a>-->
<!--      </li>-->
<!--      <li class="nav-item">-->
<!--        <a class="nav-link" routerLink="/calculations/vehicles">Calculations</a>-->
<!--      </li>-->
<!--      <li class="nav-item dropdown login-item">-->
<!--        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--          <i class="fad fa-user-circle"></i>-->
<!--        </a>-->
<!--        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">-->
<!--          <a class="dropdown-item" href="#">{{this.email}}</a>-->
<!--          <a class="dropdown-item" href="#">Another action</a>-->
<!--          <div class="dropdown-divider"></div>-->
<!--          <a class="dropdown-item" (click)="logout()"><i class="fad fa-sign-out-alt"></i> Logout</a>-->
<!--        </div>-->
<!--      </li>-->
<!--    </ul>-->
<!--  </div>-->
<!--</nav>-->
